/** @jsxImportSource @emotion/react */
import React from "react";
import { RefCallBack } from "react-hook-form";
import { css, SerializedStyles } from "@emotion/react";
import { colors } from "../../colors";
import { StyledText } from "../../../assets/typography/typography";

const inputStyle = css`
  border: none;
  min-width: fit-content;
  width: 100%;
  outline: none;
  background-color: ${colors.transparent};
  -webkit-appearance: none !important;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  errorMessage?: string;
  innerRef?: RefCallBack | React.RefObject<HTMLInputElement>;
  additionalStyles?: SerializedStyles;
}

export const BlankTextField = ({
  type,
  innerRef,
  errorMessage,
  additionalStyles,
  ...props
}: Props) => {
  const outerWrapperStyle = css`
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    gap: 8px;
    ${additionalStyles}
  `;

  return (
    <div css={outerWrapperStyle}>
      <input
        className="headerFour"
        css={inputStyle}
        type={type || "text"}
        autoComplete="off"
        ref={innerRef}
        {...props}
      />
      {errorMessage && (
        <StyledText
          className="bodySubtextRegular mb-0"
          color={colors.errorMedium}
        >
          {errorMessage}
        </StyledText>
      )}
    </div>
  );
};
